import { SortOrder } from '@cast/types';

export const ENTERPRISE_ORGANIZATION_CHILDREN_QUERY_KEY =
  'enterprise-organization-children';

export const getChildOrganizationsQueryKey = (params: {
  pageLimit?: number;
  enterpriseOrgId: string;
  search?: string;
  sortField?: string;
  sortOrder?: SortOrder;
}) =>
  [
    ENTERPRISE_ORGANIZATION_CHILDREN_QUERY_KEY,
    params.pageLimit,
    params.enterpriseOrgId,
    params.search,
    params.sortField,
    params.sortOrder,
  ] as const;
